import React, { useCallback, useState } from 'react'
import clsx from 'clsx'

import { EditorProps } from '../../../types'
import { TAB_KEY, ESC_KEY, ENTER_KEY } from '../../../utils/keys'

export interface Props extends EditorProps<string> {
  className?: string
  style?: React.CSSProperties
}

const TextEditor: React.FC<Props> = ({ value, onChange, className, style }) => {
  const [inputValue, setInputValue] = useState(value)

  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      setInputValue(event.target.value)
    },
    [],
  )

  const handleBlur = useCallback(() => {
    onChange(inputValue)
  }, [inputValue, onChange])

  const handleKeyDown = useCallback(
    ({ keyCode }: React.KeyboardEvent<HTMLInputElement>) => {
      if (keyCode === TAB_KEY || keyCode === ESC_KEY || keyCode === ENTER_KEY) {
        handleBlur()
      }
    },
    [handleBlur],
  )

  return (
    <input
      data-testid="text-editor-input"
      autoFocus
      className={clsx(
        'w-full h-full text-sm focus:outline-none bg-transparent',
        className,
      )}
      style={style}
      value={inputValue}
      onBlur={handleBlur}
      onChange={handleChange}
      onKeyDown={handleKeyDown}
    />
  )
}

export default TextEditor
